// extracted by mini-css-extract-plugin
export default {"root_image_inner":"categoryUpdationForm_root_image_inner__2QwvP","FormTabs_root":"categoryUpdationForm_FormTabs_root__u2rgi"};